import { useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Bgimage from "../../../assets/images/auth-pages-background/bg_png.png";
import Bgimage2 from "../../../assets/images/auth-pages-background/bg_png2.png";

const Careers = () => {
  useEffect(() => {
    // Prevent adding script multiple times
    const existingScript = document.getElementById("keka-script");
    if (!existingScript) {
      (window as any).khConfig = {
        identifier: "f7190ff5-a31d-49d6-a674-c231d6f083fd",
        domain: "https://techxr.keka.com/careers/",
        targetContainer: "#khembedjobs",
      };
      const script = document.createElement("script")as unknown as HTMLScriptElement;;
      script.id = "keka-script";
      script.src =
        "https://techxr.keka.com/careers/api/embedjobs/js/f7190ff5-a31d-49d6-a674-c231d6f083fd";
      script.defer = true;
      document.body.appendChild(script);
      
    }
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Career | TechXR</title>
          <meta name="title" content="Brand Ambassador Program | TechXR" />
          <meta
            name="description"
            content="Be a part of our brand ambassador and know more about the perks and benefits, roles and responsibilities. Visit our website read our program details and much more."
          />
          <meta
            property="image"
            content="https://s3-ap-south-1.amazonaws.com/co.techxr.system.backend.upload.dev/uD41orAQL8hE2zva_2023-05-30T064448436786.Img web.png"
          />
        </Helmet>
      </HelmetProvider>

      <div className="main-section mx-w-1440">
        <div className="Privacy-main py-100">
          <div className="common-container">
            <img src={Bgimage} alt="" className="bg-overlay" />
            <img src={Bgimage2} alt="" className="bg-overlay second" />
            <div className="Privacy-row">
              <div className="common-heading privacy-heading d-flex-between brandbox-main">
                <h1 className="mb-10">Career @ TechXR innovations</h1>
              </div>
              <div className="career-main-block">
                <div className="career___keka">
                  {/* Only one container, no duplicates */}
                  <div id="khembedjobs"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Careers;

